var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          { staticClass: "filter-container-new" },
          [
            _c(
              "el-form",
              {
                ref: "filterForm",
                attrs: { "label-position": "top", model: _vm.filterForm },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "not-only-required",
                            attrs: {
                              label: _vm.$t("cutTime.vesselAndVoyage"),
                              prop: "vesselFields",
                            },
                          },
                          [
                            _c("gl-ship-voyage", {
                              on: { handleOpenVessel: _vm.handleOpenVessel },
                              model: {
                                value: _vm.filterForm,
                                callback: function ($$v) {
                                  _vm.filterForm = $$v
                                },
                                expression: "filterForm",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "not-only-required",
                            attrs: {
                              label: _vm.$t("booking.blAgreementFr.blNo"),
                              prop: "blNo",
                            },
                          },
                          [
                            _c("el-input", {
                              directives: [
                                { name: "uppercase", rawName: "v-uppercase" },
                                { name: "trim", rawName: "v-trim" },
                                { name: "fth", rawName: "v-fth" },
                              ],
                              attrs: { type: "text", clearable: "" },
                              model: {
                                value: _vm.filterForm.blNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterForm, "blNo", $$v)
                                },
                                expression: "filterForm.blNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "ctnNo",
                              label: _vm.$t("booking.blAgreementFr.ctnNo"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: _vm.$t("home.select") },
                                model: {
                                  value: _vm.filterForm.ctnNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "ctnNo", $$v)
                                  },
                                  expression: "filterForm.ctnNo",
                                },
                              },
                              _vm._l(_vm.ctnNoList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      {
                        staticStyle: { "margin-top": "28px" },
                        attrs: { span: 6 },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary" },
                            on: { click: _vm.handleSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("btn.search")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-plain-primary",
                            on: { click: _vm.handleReset },
                          },
                          [_vm._v(_vm._s(_vm.$t("btn.reset")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "appStatus",
                              label: _vm.$t("booking.blAgreementFr.appStatus"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: _vm.$t("home.select") },
                                model: {
                                  value: _vm.filterForm.appStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "appStatus", $$v)
                                  },
                                  expression: "filterForm.appStatus",
                                },
                              },
                              _vm._l(_vm.appStatusList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "active",
                              label: _vm.$t("booking.blAgreementFr.active"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: _vm.$t("home.select"),
                                },
                                model: {
                                  value: _vm.filterForm.active,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "active", $$v)
                                  },
                                  expression: "filterForm.active",
                                },
                              },
                              _vm._l(_vm.activeList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "appStatusFt",
                              label: _vm.$t(
                                "booking.blAgreementFr.applyStatusFt"
                              ),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: _vm.$t("home.select") },
                                model: {
                                  value: _vm.filterForm.appStatusFt,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "appStatusFt", $$v)
                                  },
                                  expression: "filterForm.appStatusFt",
                                },
                              },
                              _vm._l(_vm.appStatusList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "activeFt",
                              label: _vm.$t("booking.blAgreementFr.activeFt"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: _vm.$t("home.select"),
                                },
                                model: {
                                  value: _vm.filterForm.activeFt,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "activeFt", $$v)
                                  },
                                  expression: "filterForm.activeFt",
                                },
                              },
                              _vm._l(_vm.activeListFt, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            staticClass: "table-container-new",
          },
          [
            _c(
              "hot-table",
              {
                ref: "hotTable",
                attrs: {
                  "data-source": _vm.tableData,
                  settings: _vm.hotSettings,
                  "current-page": _vm.filterForm.currentPage,
                  "page-size": _vm.filterForm.pageSize,
                  emptyText: _vm.$t("table.emptyText"),
                },
              },
              [
                _c("hot-column", {
                  attrs: {
                    data: "blNo",
                    title: _vm.$t("booking.blAgreementFr.blNo"),
                    "class-name": "htCenter",
                    width: "70",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "freightCode",
                    title: _vm.$t("booking.blAgreementFr.freightCode"),
                    "class-name": "htCenter",
                    width: "70",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "applyStatus",
                    title: _vm.$t("booking.blAgreementFr.appStatus"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "active",
                    title: _vm.$t("booking.blAgreementFr.active"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "vvl",
                    title: _vm.$t("booking.blAgreementFr.vvl"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "applyNo",
                    title: _vm.$t("booking.blAgreementFr.applyNo"),
                    "class-name": "htCenter",
                    width: "80",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "applyStatusFt",
                    title: _vm.$t("booking.blAgreementFr.applyStatusFt"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "activeFt",
                    title: _vm.$t("booking.blAgreementFr.activeFt"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "vvlFt",
                    title: _vm.$t("booking.blAgreementFr.vvlFt"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "demuFreeDays",
                    title: _vm.$t("booking.blAgreementFr.demuFreeDays"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "detenFreeDays",
                    title: _vm.$t("booking.blAgreementFr.detenFreeDays"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "manifestNoFt",
                    title: _vm.$t("booking.blAgreementFr.manifestNoFt"),
                    "class-name": "htCenter",
                    width: "70",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "paidType",
                    title: _vm.$t("booking.blAgreementFr.paidType"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "socCheckFlag",
                    title: _vm.$t("booking.blAgreementFr.socCheckFlag"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "manifestNo",
                    title: _vm.$t("booking.blAgreementFr.manifestNo"),
                    "class-name": "htCenter",
                    width: "70",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "fwd",
                    title: _vm.$t("booking.blAgreementFr.fwd"),
                    "class-name": "htCenter",
                    width: "120",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("pagination", {
              staticClass: "pagePanel",
              staticStyle: { "text-align": "left" },
              attrs: {
                total: _vm.total,
                page: _vm.filterForm.currentPage,
                limit: _vm.filterForm.pageSize,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.filterForm, "currentPage", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.filterForm, "pageSize", $event)
                },
                pagination: _vm.searchFn,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("sailSchedule", {
        ref: "sailSchedule",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.sailScheduleDialogVisible,
        },
        on: {
          selectionChange: _vm.selectionChange,
          "update:visible": function ($event) {
            _vm.sailScheduleDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }